// services/store/api/eventsApi.ts
import { TEvent } from "../../../types";
import { baseApi } from "./baseApi";

export const eventsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEvents: builder.query<{ events: TEvent[] }, void>({
      query: () => "/events",
      transformResponse: (res: any) => ({
        events: res.events,
      }),
      providesTags: ["Events"],
    }),

    getEventById: builder.query<any, number>({
      query: (id) => `/events/${id}`,
      transformResponse: (res: any) => ({
        event: res.event,
      }),
      providesTags: (result, error, id) => [{ type: "Events", id }],
    }),

    getMyEvents: builder.query<{ events: TEvent[] }, void>({
      query: () => "/events/mine",
      transformResponse: (res: any) => ({
        events: res.events,
      }),
      providesTags: ["Events"],
    }),

    createEventOrder: builder.mutation<
      {
        confirmation_token: string | null;
        order_id: number;
        is_free?: boolean;
        amount: number;
        base_amount: number;
        original_amount: number;
        discount_amount: number;
        tariff_price_modifier: number;
        tariff_option_title?: string | null;
        promo_code?: string | null;
      },
      { eventId: number; phone: string; promo_code?: string; event_tariff_option_id?: number; corporate_password?: string }
    >({
      query: ({ eventId, ...body }) => ({
        url: `/events/${eventId}/orders`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Events"],
    }),

    applyEventPromoCode: builder.mutation<
      {
        success: boolean;
        promo_code: string;
        amount: number;
        base_amount: number;
        original_amount: number;
        discount_amount: number;
        tariff_price_modifier: number;
        discount_type: string;
        discount_value: number;
      },
      { eventId: number; promo_code: string; event_tariff_option_id?: number }
    >({
      query: ({ eventId, promo_code, event_tariff_option_id }) => ({
        url: `/events/${eventId}/promo-code`,
        method: "POST",
        body: { promo_code, event_tariff_option_id },
      }),
    }),

    createEventFeedback: builder.mutation<
      { success: boolean; message: string; feedback_id: number },
      {
        eventId: number;
        target_profile_id: number;
        boundary_violation: boolean;
        aggressive_behavior: boolean;
        fraud_or_extortion: boolean;
        other: boolean;
        other_text: string;
      }
    >({
      query: ({ eventId, ...body }) => ({
        url: `/events/${eventId}/feedback`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Events"],
    }),
  }),
});

export const {
  useGetEventsQuery,
  useGetEventByIdQuery,
  useGetMyEventsQuery,
  useCreateEventOrderMutation,
  useApplyEventPromoCodeMutation,
  useCreateEventFeedbackMutation,
} = eventsApi;
